import { useEffect } from 'react'
import { useFeatureFlag } from '@fs/zion-flags'
import getIsTWAMode from '../helpers/appMode_helper'
import refreshTwaNotificationState from '../helpers/refreshTwaNotificationState'
import { NOTIFICATIONS_FEATURE_FLAG } from '../services/notificationPrefsService'

/**
 * In the Android TWA, re-syncs the OS notification permission whenever the app returns to the foreground.
 *
 * Without this, a change made in system settings while the app was only backgrounded (not fully closed)
 * isn't reflected until a cold relaunch. On each foreground (`visibilitychange` → visible) we ask the
 * native side to re-check; it only relaunches the TWA when the permission actually changed, so ordinary
 * app-switching doesn't trigger a reload. Gated by the notifications feature flag.
 */
export default function useRefreshNotificationStateOnResume() {
  const featureEnabled = useFeatureFlag(NOTIFICATIONS_FEATURE_FLAG).isOn

  useEffect(() => {
    const active = featureEnabled && getIsTWAMode()

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshTwaNotificationState()
    }

    if (active) {
      document.addEventListener('visibilitychange', onVisibilityChange)
    }

    return () => {
      if (active) document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [featureEnabled])
}
